<template>
  <div>
    <el-table :data="items" :row-key="row_key">
      <el-table-column label="Сервер" prop="domain">
        <template slot-scope="scope">
          {{ scope.row.domain }}
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button
            class="delete_button"
            size="small"
            type="primary"
            :loading="isDeleteButtonLoading"
            @click="() => handleDeleteIntermediateServerButton(scope.row)"
          >
            Удалить
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="list__pagination"
      layout="prev, pager, next"
      :page-size="count"
      :total="total"
      :current-page="page"
      @current-change="handleChangePage"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ReserveTransfersIntermediateServers",
  components: {},
  props: {
    handleIsLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      isDeleteButtonLoading: false,
      page: 1,
    };
  },
  computed: {
    ...mapState("reserveTransfers", {
      items: (state) => state.intermediateServers.data,
      total: (state) => state.intermediateServers.total,
      count: (state) => state.intermediateServers.count,
    }),
    ...mapState("auth", ["token"]),
  },
  watch: {
    loading() {
      this.handleIsLoading(this.loading);
    },
  },
  created() {
    this.loading = true;

    this.getIntermediateServersList({
      page: this.page,
      count: this.count,
    }).finally(() => (this.loading = false));
    this.intervalId = setInterval(() => {
      this.loading = true;
      this.getIntermediateServersList({
        page: this.page,
        count: this.count,
      }).finally(() => (this.loading = false));
    }, 8000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    ...mapActions("reserveTransfers", {
      getIntermediateServersList: "GET_INTERMEDIATE_SERVERS_LIST",
      deleteIntermediateServer: "DELETE_INTERMEDIATE_SERVER",
    }),
    handleDeleteIntermediateServerButton(intermediateServer) {
      this.$confirm(
        `Удалить сервер ${intermediateServer.domain}
          из списка промежуточных`,
        "Обслуживание",
        {
          confirmButtonText: "Удалить",
        }
      ).then(() => {
        this.isDeleteButtonLoading = true;

        this.deleteIntermediateServer(intermediateServer.id_server)
          .then(() => {
            this.getIntermediateServersList({
              page: this.page,
              count: this.count,
            });
            this.$message({
              message: "Сервер удален",
              type: "success",
            });
          })
          .catch((e) => {
            if (e !== "cancel") {
              this.$message({
                type: "error",
                message: e?.response?.data.error || "Неизвестная ошибка",
              });
            }
          })
          .finally(() => { this.isDeleteButtonLoading = false; });
      });
    },
    row_key(row) {
      return row.id_reserve_transfer_intermediate_server;
    },
    handleChangePage(page) {
      this.expandRowKeys = [];
      this.page = page;

      this.loading = true;
      this.getList({
        page,
        count: this.count,
        return_status: this.isArchive ? 1 : 0,
      }).finally(() => (this.loading = false));
    },
  },
};
</script>

<style>
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.no-expand .el-icon {
  display: none;
}
.no-expand .el-table__expand-icon {
  pointer-events: none;
}
.delete_button {
  text-wrap: wrap;
  width: 144px;
}
</style>
